import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MessageService } from './message.service';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class ConfigDataService {

    private configUrl = location.origin + '/api/config/';

    private token = localStorage.getItem('token');

    private headers = new HttpHeaders().set('Content-Type', 'application/json');
    httpOptions = this.headers.append('Authorization', `Bearer ${this.token}`);

    constructor(private http: HttpClient, private messageService: MessageService) { }

    getToken() {
        return this.headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    }

    /** Get all config */
    getConfigList(): Observable<any> {
        return this.http.get<any>(`${this.configUrl}admin/all`, { headers: this.getToken() });
    }

    addNewTenantConfig(tenantConfig: any): Observable<any> {
        return this.http.post<any>(`${this.configUrl}admin`, tenantConfig, { headers: this.getToken() })
            .pipe();
    }

    getTenant(tenantId: string): Observable<any> {
        return this.http.get<any>(`${this.configUrl}admin/get/${tenantId}`, { headers: this.getToken() });
    }

    setPrivateConfig(configPair: any, tenant: string): Observable<any> {
        return this.http.post<any>(`${this.configUrl}private/${tenant}/${configPair.key}`, configPair.val, { headers: this.getToken() });
    }

    setPublicConfig(configPair: any, tenant: string): Observable<any> {
        return this.http.post<any>(`${this.configUrl}public/${tenant}/${configPair.key}`, configPair.val, { headers: this.getToken() });
    }

    addOrUpdatePrivateConfigList(configPairList: any, tenant: string): Observable<any> {
        return this.http.post<any>(`${this.configUrl}private/list/add/${tenant}`, configPairList, { headers: this.getToken() });
    }

    addOrUpdatePublicConfigList(configPairList: any, tenant: string): Observable<any> {
        return this.http.post<any>(`${this.configUrl}public/list/add/${tenant}`, configPairList, { headers: this.getToken() });
    }

    addOrUpdateEmailConfigList(configPairList: any, tenant: string): Observable<any> {
        return this.http.post<any>(`${this.configUrl}email/list/add/${tenant}`, configPairList, { headers: this.getToken() });
    }

    updateTenantBasic(data: any): Observable<any> {
        return this.http.post<any>(`${this.configUrl}update`, data, { headers: this.getToken() });
    }

    getValueByKey(key: string): Observable<any> {
        return this.http.get<any>(`${this.configUrl}get/key/${key}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    getvalueByPublicKeys(keyList): Observable<any> {
        return this.http.post<any>(`${this.configUrl}public/key/list`, keyList, {})
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

}